// ServicesScreen.jsx — faqja "Shërbimet" në aplikacion (Faza 0)
//
// Vitrina + porosia + "Porositë e mia", në një ekran. Vizaton VETËM atë që i
// kthen `rpc_services_for_me` — pra atë që admini ka ndezur për këtë familje.
// Me katalog bosh, ky ekran as nuk arrihet: hyrja në navigim shfaqet vetëm kur
// ka ≥1 shërbim (shih App.jsx). Kështu menuja nuk ndryshon kurrë kot.
//
// Pagesa është e vetëdijshme jashtë këtij ekrani (vendimi i pronarit, 20 gusht):
// porosia dërgohet, dhe stafi kontakton për pagesën. Teksti poshtë formularit e
// thotë hapur — një premtim i vogël dhe i vërtetë vlen më shumë se një buton
// "Paguaj" që s'paguan gjë.
//
// WIRING (App.jsx):
//   import ServicesScreen from "./ServicesScreen.jsx";
//   {!locked && activeScreen === "services" && (
//     <ServicesScreen familyId={activeFamilyId} C={COLORS} F={FONTS} t={t} />
//   )}

import React, { useCallback, useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import { featureOn, onFeaturesChange } from "./features.js";

const eur = (c) => (c / 100).toFixed(2).replace(".", ",") + " €";

// Statuset me fjalët e klientit — jo zhargon pipeline-i.
const STATUS_SQ = {
  submitted: "E dërguar",
  awaiting_payment: "Në pritje të pagesës",
  paid: "E paguar",
  shipped: "E nisur me postë",
  // 'ready' ndodh VETËM te porositë që merren në dorë — prandaj një fjalë e
  // vetme mjafton, pa kushte.
  ready: "Gati për marrje",
  in_progress: "Në punë",
  review: "Në rishikim",
  delivered: "E dorëzuar",
  completed: "E përfunduar",
  cancelled: "E anuluar",
  refunded: "E rimbursuar",
};
// Ku ndodhet porosia në rrugëtim — për shiritin e vogël të përparimit.
const STATUS_STEP = { submitted: 1, awaiting_payment: 2, paid: 3, in_progress: 4, review: 4, ready: 5, shipped: 5, delivered: 5, completed: 5 };

export default function ServicesScreen({ familyId, C, F, t, onGenerateBook, renderHapesiren }) {
  const [services, setServices] = useState(null);
  const [orders, setOrders] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [openKey, setOpenKey] = useState(null);     // karta e hapur për porosi
  // FUSHAT E POROSISË (Faza 1a) — vijnë nga `service_catalog.config.fields`, pra
  // nga konfigurimi, jo nga kodi. Një poster i shtypur kërkon përmasë dhe adresë;
  // një libër digjital s'kërkon asgjë. Kjo formë s'di paraprakisht as njërën.
  const [fieldVals, setFieldVals] = useState({});
  const [fieldErr, setFieldErr] = useState("");
  // FORMATI I ZGJEDHUR, per shërbim (Faza 1b). Pa këtë, një shërbim me pesë
  // çmime do të porositej gjithmonë me të parin — defekt që s'do të dukej te
  // ekrani, vetëm te fatura.
  const [variantPick, setVariantPick] = useState({});
  const priceOf = (svc) => {
    const ps = svc.prices || [];
    const picked = variantPick[svc.service_key];
    return ps.find((p) => p.price_id === picked) || ps[0];
  };
  const [note, setNote] = useState("");
  const [qty, setQty] = useState(1);
  const [placed, setPlaced] = useState(null);       // {order_no} — konfirmimi
  // Udhëzimet e pagesës — tekst i administruar nga Admin Center (Faza 0b).
  // Shfaqen te konfirmimi dhe te çdo porosi "Në pritje të pagesës", që klienti
  // të mos shohë kurrë një status pa ditur çfarë pritet prej tij.
  const [payInfo, setPayInfo] = useState("");
  // Rivizatohu kur flag-et ndryshojnë — pas pagesës, entitlement-i `family_book`
  // e ndez butonin e gjenerimit pa rifreskim faqeje.
  const [, setFeatTick] = useState(0);
  useEffect(() => onFeaturesChange(() => setFeatTick((n) => n + 1)), []);
  const [bookBusy, setBookBusy] = useState(false);
  const [bookErr, setBookErr] = useState("");
  // Në telefon dorëzimi mund të mbarojë pa Share-Sheet (p.sh. i anuluar a i
  // padisponueshëm) — atëherë skedari ekziston, por asgjë s'e tregon. Kjo linjë
  // e tregon.
  const [bookNote, setBookNote] = useState("");
  const [abonimi, setAbonimi] = useState(null);
  const [dhuratat, setDhuratat] = useState([]);

  const load = useCallback(() => {
    if (!familyId) return;
    supabase.rpc("rpc_services_for_me", { p_family_id: familyId }).then(({ data, error }) => {
      if (error) { setErr(error.message); return; }
      setServices(data || []);
    });
    supabase.rpc("rpc_my_orders", { p_family_id: familyId }).then(({ data, error }) => {
      if (!error) setOrders(data || []);
    });
    supabase.rpc("rpc_commerce_info").then(({ data, error }) => {
      if (!error && typeof data === "string") setPayInfo(data);
    });
    // Nëse FAZA2b s'është xhiruar, kjo bie dhe lista mbetet bosh — pra pa zona
    // posta, pikërisht si sot. Mungesa e një veçorie s'duhet ta prishë faqen.
    supabase.rpc("rpc_shipping_options").then(({ data, error }) => {
      if (error || !Array.isArray(data)) return;
      setShipRates(data);
      setShipRate((cur) => cur || (data[0] ? data[0].id : ""));
    });
    // ABONIMI. `rpc_my_subscription` ekzistonte që nga Faza 2a dhe s'e thërriste
    // askush — pra familja paguante, ose dikush paguante PËR të, dhe askund nuk
    // dukej deri kur. E gjeti `tools/rpcmap.cjs`.
    supabase.rpc("rpc_my_subscription", { p_family_id: familyId }).then(({ data, error }) => {
      if (error) return;                       // SQL-ja s'është xhiruar ende
      setAbonimi((Array.isArray(data) ? data[0] : data) || null);
    });
    // ÇFARË PAGUAJ UNË — pa parametër familjeje me qëllim. Kjo listë s'i takon
    // familjes aktive; i takon llogarisë. Dikush në Zvicër mund të mbajë pemën e
    // një familjeje ku nuk bën pjesë fare, dhe ai ekran duhet ta ndjekë atë, jo
    // familjen që ka hapur për momentin.
    supabase.rpc("rpc_my_gifts").then(({ data, error }) => {
      if (error) return;
      setDhuratat(Array.isArray(data) ? data : []);
    });
  }, [familyId]);
  useEffect(() => { load(); }, [load]);

  const place = async (svc) => {
    const price = priceOf(svc);
    if (!price) { setErr(t("This service has no price yet — try again later.")); return; }
    // Kontrolli i parë këtu është mirësjellje: thotë ÇFARË mungon pa e dërguar
    // fare porosinë. Rregulli i vërtetë rri te serveri (`fn_validate_input`) —
    // një formë e anashkaluar s'kalon dot atje.
    const missing = (svc.fields || []).find((f) => {
      if (!f.required) return false;
      const v = fieldVals[f.key];
      return v == null || String(v).trim() === "";
    });
    if (missing) { setFieldErr(missing.label || missing.key); return; }
    setFieldErr("");
    const input = {};
    (svc.fields || []).forEach((f) => {
      const v = fieldVals[f.key];
      if (v != null && String(v).trim() !== "") input[f.key] = v;
    });
    if (note.trim()) input.note = note.trim();
    setBusy(true); setErr("");
    // Adresa dërgohet vetëm kur diçka dërgohet vërtet. Serveri e kërkon
    // gjithsesi për `physical` — kjo këtu është mirësjellje, jo mbrojtje.
    const fizik = svc.kind === "physical";
    // Me marrje në dorë, adresa e dërgesës bëhet adresa e shtypshkronjës:
    // serveri e kërkon gjithsesi për `physical`, dhe kështu blerësi jep vetëm
    // emrin e telefonin — jo një adresë shtëpie që s'do të përdoret kurrë.
    const adresa = fizik
      ? (marrjaVete
          ? { ...shipTo, address: marrjaVete.adresa || shipTo.address,
              city: marrjaVete.qyteti || shipTo.city, country: shipTo.country }
          : shipTo)
      : null;
    const { data, error } = await supabase.rpc("rpc_place_order", {
      p_family_id: familyId,
      p_items: [{ price_id: price.price_id, qty, input }],
      p_notes: null,
      p_ship_to: adresa,
      p_shipping_rate: (fizik && !shipIncluded && !marrjaVete) ? (shipRate || null) : null,
    });
    if (error) { setBusy(false); setErr(error.message); return; }
    const row = Array.isArray(data) ? data[0] : data;

    // Hapi i dytë, dhe qëllimisht i dytë: `rpc_place_order` i takon FAZA2b dhe
    // është xhiruar. Ta zgjeroja me një parametër do të thoshte dy pronarë për
    // një funksion — kurthi që na ka zënë tri herë. Porosia krijohet si
    // gjithmonë, pastaj thuhet "e marr vetë".
    //
    // Nëse ky hap dështon, porosia EKZISTON dhe posta mbetet e ngarkuar. Prandaj
    // gabimi nuk hesht: blerësi e sheh dhe di të kërkojë ndreqjen para se të
    // paguajë.
    if (marrjaVete && row?.order_id) {
      const { error: e2 } = await supabase.rpc("rpc_my_order_set_pickup", {
        p_order_id: row.order_id, p_vendor_id: marrjaVete.id,
      });
      if (e2) {
        setBusy(false);
        setErr(t("The order was created, but switching to collection failed") + ": " + e2.message);
        load();
        return;
      }
    }
    setBusy(false);
    setPlaced({ order_no: row?.order_no || "" });
    setOpenKey(null); setNote(""); setQty(1); setFieldVals({}); setFieldErr(""); setPickup("");
    load();
  };

  // ADRESA DHE POSTA (Faza 2b). Adresa rri te POROSIA, jo te artikulli: një
  // dërgesë ka një adresë, dhe dy kopje që mund të mos përputhen janë defekt me
  // vonesë. Shfaqet vetëm kur diçka dërgohet vërtet — `kind === 'physical'`.
  const [shipTo, setShipTo] = useState({ name: "", phone: "", address: "", city: "", country: "Kosovë" });
  const [shipRates, setShipRates] = useState([]);
  const [shipRate, setShipRate] = useState("");

  // MARRJA NË DORË (Faza 3c). Pyetja i bëhet blerësit vetëm kur ka kuptim:
  // platforma e lejon, shtypshkronja pranon njerëz te dera, dhe ajo ndodhet te
  // qyteti i tij ose te një zonë e shënuar si e afërt. Përndryshe s'e sheh fare
  // — një zgjedhje që s'i vlen është një zgjedhje që duhet lexuar.
  const [pickupOpts, setPickupOpts] = useState([]);
  const [pickup, setPickup] = useState("");        // "" = me postë
  const [copied, setCopied] = useState("");
  const marrjaVete = pickupOpts.find((x) => x.id === pickup) || null;
  const shipIncluded = shipRates.length > 0 && shipRates[0].e_perfshire === true;
  const rateOf = (id) => shipRates.find((r) => r.id === id);

  // Qyteti shkruhet shkronjë për shkronjë; pyetja pritet 400ms. Pa këtë,
  // "Prishtinë" do të dërgonte nëntë kërkesa dhe lista do të kërcente.
  useEffect(() => {
    const q = (shipTo.city || "").trim();
    if (q.length < 3) { setPickupOpts([]); setPickup(""); return; }
    const t = setTimeout(() => {
      supabase.rpc("rpc_pickup_options", { p_city: q }).then(({ data, error }) => {
        // Nëse FAZA3c s'është xhiruar, kjo bie dhe blerësi thjesht s'e sheh
        // opsionin — pikërisht si dje. Mungesa e një veçorie s'prish faqe.
        if (error || !Array.isArray(data)) { setPickupOpts([]); return; }
        setPickupOpts(data);
        setPickup((cur) => (data.some((x) => x.id === cur) ? cur : ""));
      });
    }, 400);
    return () => clearTimeout(t);
  }, [shipTo.city]);

  // BISEDA E POROSISË (Faza 2b). Deri sot blerësi vetëm shihte statusin — as kur
  // i kërkohej pagesa s'kishte ku të thoshte një fjalë.
  const [thread, setThread] = useState({});     // order_id → rreshtat
  const [msg, setMsg] = useState({});           // order_id → teksti që po shkruhet
  const [payRef, setPayRef] = useState({});
  const openThread = async (orderId) => {
    if (thread[orderId]) { setThread((t0) => ({ ...t0, [orderId]: null })); return; }
    const { data, error } = await supabase.rpc("rpc_order_thread", { p_order_id: orderId });
    if (error) { setErr(error.message); return; }
    setThread((t0) => ({ ...t0, [orderId]: data || [] }));
    // Hapja ËSHTË leximi. Një buton "shëno si të lexuar" do të ishte një hap më
    // shumë që askush s'e shtyp, dhe shenja do të rrinte aty përgjithmonë.
    // Gabimi nuk i tregohet përdoruesit — shenja e palexuar që mbetet aty s'e
    // ndal punën e tij. Por shkruhet te konsola, sepse ndryshe një `rpc_order_seen`
    // që dështon gjithmonë do të dukej si "shenjat nuk fshihen kurrë" dhe do të
    // kërkohej te vendi i gabuar.
    const { error: eSeen } = await supabase.rpc("rpc_order_seen", { p_order_id: orderId });
    if (eSeen) console.error("rpc_order_seen:", eSeen.message);
    load();
  };
  const sendMsg = async (orderId) => {
    const text = (msg[orderId] || "").trim();
    if (!text) return;
    const { error } = await supabase.rpc("rpc_order_message", { p_order_id: orderId, p_text: text });
    if (error) { setErr(error.message); return; }
    setMsg((m) => ({ ...m, [orderId]: "" }));
    const { data, error: eTh } = await supabase.rpc("rpc_order_thread", { p_order_id: orderId });
    if (eTh) { setErr(eTh.message); return; }
    setThread((t0) => ({ ...t0, [orderId]: data || [] }));
  };
  // NUK e shënon porosinë të paguar — e thotë. Verifikimin e bën stafi te banka.
  // Një buton që e ndryshon vetë statusin do të ishte buton që gënjen.
  const declarePaid = async (orderId) => {
    const { error } = await supabase.rpc("rpc_my_order_declare_payment", {
      p_order_id: orderId, p_ref: (payRef[orderId] || "").trim() || null, p_note: null,
    });
    if (error) { setErr(error.message); return; }
    setPayRef((r) => ({ ...r, [orderId]: "" }));
    load();
    if (thread[orderId]) openThread(orderId), openThread(orderId);
  };

  // "E MORA" — hapi i fundit, dhe i vetmi që s'e di dot askush tjetër.
  //
  // Posta e njofton dërguesin, jo ne. Pa këtë buton, një porosi e nisur mbetet
  // e hapur derisa dikush te stafi ta mbyllë me hamendje — dhe hamendja e njërit
  // bëhet "e dorëzuar" te raporti i tjetrit.
  //
  // `rpc_my_order_received` ekzistonte që dje. Butoni jo: e shkrova funksionin
  // dhe s'e lidha kurrë me ndërfaqen. E gjeti `tools/rpcmap.cjs`, jo unë.
  const confirmReceived = async (orderId) => {
    if (!window.confirm(t("Confirm that the order arrived? This closes it."))) return;
    const { error } = await supabase.rpc("rpc_my_order_received", { p_order_id: orderId });
    if (error) { setErr(error.message); return; }
    load();
  };

  // SKEDARI I POROSISË (Faza 1i). Kush vendos nëse hapet nuk është kjo faqe —
  // është serveri. Ndryshe do të kishim dy lista statusesh "të paguara": një te
  // baza dhe një te JavaScript-i, dhe kjo e dyta do të vjetërohej e para.
  // VETËM PAMJE. Kjo listë nuk vendos asgjë — nëse gabon, butoni duket i artë
  // dhe klikimi kthen "hapet pas pagesës". Autoriteti mbetet te RLS-ja e
  // `order-artwork` dhe te `rpc_my_order_files`.
  // 'ready' dhe 'shipped' mungonin këtu — dhe mungonin edhe te `fn_my_order_paid`
  // te serveri. Pra sapo porosia nisej, butoni i shkarkimit dukej i kyçur DHE
  // ishte vërtet i kyçur. Askush s'do ta kishte raportuar: dukej si "s'po
  // hapet", dhe pas dy ditësh hapej vetë.
  const fn_paidLook = (st) =>
    ["paid", "in_progress", "review", "ready", "shipped", "delivered", "completed"].includes(st);

  const [dlBusy, setDlBusy] = useState(null);
  const openArtwork = async (orderId) => {
    setDlBusy(orderId); setErr("");
    const { data, error } = await supabase.rpc("rpc_my_order_files", { p_order_id: orderId });
    if (error) { setDlBusy(null); setErr(error.message); return; }
    const rows = data || [];
    if (rows.some((f) => f.ende_pa_pagese)) {
      setDlBusy(null);
      setErr(t("The file opens as soon as the payment is confirmed."));
      return;
    }
    for (const f of rows) {
      if (!f.path) continue;
      const { data: sig, error: se } = await supabase.storage
        .from("order-artwork").createSignedUrl(f.path, 3600);
      if (se) { setDlBusy(null); setErr(se.message); return; }
      window.open(sig.signedUrl, "_blank", "noopener");
    }
    setDlBusy(null);
  };

  const cancel = async (orderId) => {
    setBusy(true); setErr("");
    const { error } = await supabase.rpc("rpc_cancel_my_order", { p_order_id: orderId });
    setBusy(false);
    if (error) { setErr(error.message); return; }
    load();
  };

  const card = { background: C.panel, border: `1px solid ${C.goldSoft}`, borderRadius: 14 };
  const fieldStyle = {
    width: "100%", padding: "8px 10px", borderRadius: 8, border: `1px solid ${C.goldSoft}`,
    background: "transparent", color: C.ink, fontFamily: F.body, fontSize: 13,
  };

  return (
    <div className="flex-1 overflow-y-auto px-4 py-4"
      style={{ background: `radial-gradient(circle at 20% 10%, ${C.bgDeep}, ${C.bg} 70%)` }}>
      <div className="max-w-2xl mx-auto">
        <p className="mb-1" style={{ fontFamily: F.display, fontSize: 20, fontWeight: 600, color: C.onBg }}>
          {t("Services")}
        </p>
        <p className="mb-4" style={{ fontFamily: F.body, fontSize: 12.5, color: C.onBg, opacity: 0.65, lineHeight: 1.5 }}>
          {t("Things made from your family's own story — its people, dates and photos.")}
        </p>

        {err && (
          <p className="mb-3 px-3 py-2 rounded-md" style={{ background: "#FBEAEA", color: "#8A2E2E", fontFamily: F.body, fontSize: 12.5 }}>{err}</p>
        )}

        {/* HAPËSIRA · 3 shtator 2026 — SHTËPIA E NUMRAVE.
            Kartela e hapësirës rrinte mbi Historinë, ku zinte vend dhe binte në
            sy më shumë se përmbajtja që njeriu erdhi ta shohë. Aty tani hesht
            derisa të ketë diçka për të thënë; pamja e plotë erdhi këtu, sepse
            këtu edhe shitet — «Zgjero hapësirën» s'ka ku të të çojë më afër.
            Vjen si funksion nga App.jsx: ky ekran s'ka nevojë të dijë asgjë për
            kuota, mënyra apo ngjyra. */}
        {typeof renderHapesiren === "function" ? renderHapesiren() : null}

        {/* ABONIMI — dhe kush e paguan.
            Emri i paguesit nuk është zbukurim. Sipas strategjisë, dhurimi është
            mekanizmi më i rëndësishëm komercial i platformës: dikush në Zvicër
            paguan, familja në Kosovë përfiton. Nëse familja s'e sheh kurrë se
            kush e mban, dhurata bëhet e padukshme — dhe një dhuratë e padukshme
            nuk falënderohet, nuk kujtohet, dhe nuk përsëritet vitin tjetër. */}
        {abonimi && abonimi.plan && (
          <div className="mb-3 p-3 rounded-lg"
            style={{ ...card, borderColor: abonimi.dite_te_mbetura != null && abonimi.dite_te_mbetura <= 14 ? C.gold : C.goldSoft }}>
            <div className="flex items-center gap-2">
              <span style={{ fontFamily: F.body, fontSize: 13.5, fontWeight: 700, color: C.ink }}>
                {abonimi.e_dhuruar ? "🎁 " : ""}{t("Plan")}: {abonimi.plan}
              </span>
              <span style={{ flex: 1 }} />
              <span style={{ fontFamily: F.body, fontSize: 12, color: C.inkLight }}>{abonimi.status}</span>
            </div>
            {abonimi.deri && (
              <p className="mt-1" style={{ fontFamily: F.body, fontSize: 12.5, color: C.inkLight }}>
                {t("Until")} {new Date(abonimi.deri).toLocaleDateString("sq")}
                {abonimi.dite_te_mbetura != null && <> · {abonimi.dite_te_mbetura} {t("days left")}</>}
              </p>
            )}
            {abonimi.e_dhuruar && abonimi.paguesi && (
              <p className="mt-1" style={{ fontFamily: F.body, fontSize: 12.5, color: C.gold }}>
                {t("A gift from")} {abonimi.paguesi}
              </p>
            )}
          </div>
        )}

        {/* ÇFARË PAGUAJ UNË — ekrani që i mungonte paguesit.
            Shfaqet vetëm nëse ka diçka për të treguar, dhe vetëm rreshtat që
            kërkojnë vëmendje ose një familje tjetër nga kjo. Një listë që
            përsërit atë që sapo u tha dy centimetra më lart nuk lexohet. */}
        {dhuratat.filter((g) => g.kujton || !g.e_imja).length > 0 && (
          <div className="mb-3 p-3 rounded-lg" style={{ ...card, borderColor: C.goldSoft }}>
            <p className="mb-2" style={{ fontFamily: F.body, fontSize: 13, fontWeight: 700, color: C.ink }}>
              {t("What I pay for")}
            </p>
            {dhuratat.filter((g) => g.kujton || !g.e_imja).map((g) => {
              const skaduar = g.dite_te_mbetura === 0;
              return (
                <div key={g.family_id} className="flex items-center gap-2 py-1"
                  style={{ fontFamily: F.body, fontSize: 12.5, color: C.inkLight }}>
                  <span>{g.e_imja ? "" : "🎁 "}<b style={{ color: C.ink }}>{g.familja}</b> · {g.plan}</span>
                  <span style={{ flex: 1 }} />
                  <span style={{ color: g.kujton ? (skaduar ? "#A3331A" : C.gold) : C.inkLight,
                                 fontWeight: g.kujton ? 700 : 400 }}>
                    {skaduar ? t("expired")
                             : `${g.dite_te_mbetura} ${t("days left")}`}
                  </span>
                </div>
              );
            })}
            {/* Pse s'ka buton "rinovo": rinovimi është porosi, dhe porositë
                bëhen te vitrina poshtë — me çmimin, me faturën, me rrjedhën e
                vet. Një shkurtore këtu do të krijonte një rrugë të dytë blerjeje
                që një ditë do të ndahej nga e para. */}
            <p className="mt-1" style={{ fontFamily: F.body, fontSize: 11, color: C.inkLight, opacity: 0.8 }}>
              {t("To renew, order the plan again below.")}
            </p>
          </div>
        )}

        {/* Konfirmimi pas porosisë — i madh dhe i qartë, sepse është hera e
            parë që dikush i jep para platformës dhe s'duhet të mbetet me dyshim. */}
        {placed && (
          <div className="mb-4 p-4" style={{ ...card, borderColor: C.gold }}>
            <p style={{ fontFamily: F.body, fontSize: 14, fontWeight: 700, color: C.ink }}>
              ✓ {t("Your order was received.")}
            </p>
            <p style={{ fontFamily: F.mono, fontSize: 13, color: C.gold, margin: "4px 0" }}>{placed.order_no}</p>
            <p style={{ fontFamily: F.body, fontSize: 12.5, color: C.inkLight, lineHeight: 1.6 }}>
              {t("We will contact you about payment and you can follow every step below, under My orders.")}
            </p>
            {payInfo && (
              <p style={{ fontFamily: F.body, fontSize: 12.5, color: C.ink, lineHeight: 1.6,
                          whiteSpace: "pre-wrap", marginTop: 8, padding: "8px 10px",
                          background: C.panelSoft, borderRadius: 8 }}>{payInfo}</p>
            )}
            <button onClick={() => setPlaced(null)} className="mt-2 px-3 py-1.5 rounded-md text-xs"
              style={{ border: `1px solid ${C.goldSoft}`, color: C.ink, background: "transparent", cursor: "pointer" }}>
              {t("Close")}
            </button>
          </div>
        )}

        {/* Libri i Familjes — shfaqet VETËM me entitlement (pas pagesës).
            Ky është produkti i parë `auto`: klienti e prodhon vetë, aty për
            aty, nga të dhënat e veta — stafi nuk prek asgjë. */}
        {featureOn("family_book") && onGenerateBook && (
          <div className="mb-3 p-4" style={{ ...card, borderColor: C.gold }}>
            <p style={{ fontFamily: F.display, fontSize: 16, fontWeight: 600, color: C.ink }}>
              📖 {t("Your Family Book")}
            </p>
            <p style={{ fontFamily: F.body, fontSize: 12.5, color: C.inkLight, lineHeight: 1.55, marginTop: 3 }}>
              {t("A PDF built from your own tree: the people, dates, birthplaces, photos and memories. Generate it as many times as you like — it always reflects the tree as it is today.")}
            </p>
            {bookErr && <p style={{ fontFamily: F.body, fontSize: 12, color: "#8A2E2E", marginTop: 6 }}>{bookErr}</p>}
            {bookNote && <p style={{ fontFamily: F.body, fontSize: 12, color: C.inkLight, marginTop: 6 }}>{bookNote}</p>}
            <button
              disabled={bookBusy}
              onClick={async () => {
                setBookBusy(true); setBookErr(""); setBookNote("");
                try { const note = await onGenerateBook(); if (note) setBookNote(note); }
                catch (e) { setBookErr(t("Could not generate: ") + (e?.message || e)); }
                finally { setBookBusy(false); }
              }}
              className="mt-3 w-full py-2.5 rounded-lg text-sm font-semibold"
              style={{ background: C.gold, color: C.bgDeep, border: "none", cursor: "pointer",
                       fontFamily: F.body, opacity: bookBusy ? 0.6 : 1 }}>
              {bookBusy ? t("Generating… (photos take a moment)") : t("⬇ Generate the book (PDF)")}
            </button>
          </div>
        )}

        {/* ---------------- VITRINA ---------------- */}
        {services === null ? (
          <p style={{ fontFamily: F.body, fontSize: 13, color: C.onBg, opacity: 0.6 }}>{t("Loading…")}</p>
        ) : services.length === 0 ? (
          <p style={{ fontFamily: F.body, fontSize: 13, color: C.onBg, opacity: 0.6 }}>
            {t("Nothing here yet.")}
          </p>
        ) : services.map((svc) => {
          const ps = svc.prices || [];
          const price = priceOf(svc);
          const many = ps.length > 1;
          const open = openKey === svc.service_key;
          const physical = svc.kind === "physical";
          return (
            <div key={svc.service_key} className="mb-3 p-4" style={card}>
              <div className="flex items-start gap-3">
                <div style={{ flex: 1 }}>
                  <p style={{ fontFamily: F.display, fontSize: 16, fontWeight: 600, color: C.ink }}>{svc.name}</p>
                  {svc.description && (
                    <p style={{ fontFamily: F.body, fontSize: 12.5, color: C.inkLight, lineHeight: 1.55, marginTop: 3 }}>
                      {svc.description}
                    </p>
                  )}
                </div>
                <div style={{ textAlign: "right", flexShrink: 0 }}>
                  {price ? (
                    <p style={{ fontFamily: F.body, fontSize: 16, fontWeight: 700, color: C.gold }}>
                      {many && !open
                        ? `${eur(Math.min(...ps.map((x) => x.amount_cents)))} – ${eur(Math.max(...ps.map((x) => x.amount_cents)))}`
                        : eur(price.amount_cents)}
                      {price.billing !== "one_time" && (
                        <span style={{ fontSize: 11, fontWeight: 400, color: C.inkLight }}>
                          /{price.billing === "monthly" ? t("month") : t("year")}
                        </span>
                      )}
                    </p>
                  ) : (
                    <p style={{ fontFamily: F.body, fontSize: 12, color: C.inkLight }}>{t("price to come")}</p>
                  )}
                </div>
              </div>

              {svc.owned ? (
                /* E zotëruar tashmë — dyqani modern s'i shet dy herë të njëjtën
                   gjë: shenjë e qetë në vend të butonit. Serveri e refuzon
                   gjithsesi riblerjen; kjo është vetëm mirësjellja e vitrinës. */
                <p className="mt-3 py-2 rounded-lg text-sm font-semibold" style={{
                  textAlign: "center", background: C.panelSoft, color: C.gold, fontFamily: F.body }}>
                  ✓ {t("Unlocked for your family")}
                </p>
              ) : !open ? (
                <button onClick={() => { setOpenKey(svc.service_key); setNote(""); setQty(1); setPlaced(null); setFieldErr(""); setFieldVals(Object.fromEntries((svc.fields || []).filter((f) => f.default != null).map((f) => [f.key, f.default]))); }}
                  disabled={!price}
                  className="mt-3 w-full py-2.5 rounded-lg text-sm font-semibold"
                  style={{ background: price ? C.gold : C.panelSoft, color: price ? C.bgDeep : C.inkLight,
                           border: "none", cursor: price ? "pointer" : "default", fontFamily: F.body }}>
                  {t("Order")}
                </button>
              ) : (
                <div className="mt-3">
                  {physical && (
                    <div className="flex items-center gap-2 mb-2">
                      <span style={{ fontFamily: F.body, fontSize: 12.5, color: C.inkLight }}>{t("Quantity")}:</span>
                      {[1, 2, 3, 4, 5].map((n) => (
                        <button key={n} onClick={() => setQty(n)} style={{
                          width: 30, height: 30, borderRadius: 8, cursor: "pointer", fontFamily: F.body, fontSize: 13,
                          border: `1px solid ${qty === n ? C.gold : C.goldSoft}`,
                          background: qty === n ? C.accentTint || C.panelSoft : "transparent",
                          color: C.ink, fontWeight: qty === n ? 700 : 400,
                        }}>{n}</button>
                      ))}
                    </div>
                  )}
                  {/* FORMATI. Nuk është fushë porosie — është ÇMIM, dhe prandaj
                      zgjedhësi tregon shumën përkrah secilit. Zgjedhja e formatit
                      është zgjedhja e `price_id`, ndaj çmimi ngrihet aty për aty
                      pikërisht ai që u pa. */}
                  {many && (
                    <div className="mb-3">
                      {/* NJË ABONIM NUK KA FORMAT, KA AFAT. Po t'i thuash "Formati:
                          yearly / monthly", pyetja duket teknike dhe përgjigjja e
                          pakuptimtë. Kur çdo çmim i shërbimit është i përsëritur,
                          zgjedhësi ndërron fjalë — dhe butonat tregojnë afatin, jo
                          emrin e variantit që u shtyp te Admin Center. */}
                      <label style={{ fontFamily: F.body, fontSize: 12, color: C.inkLight, display: "block", marginBottom: 4 }}>
                        {ps.every((p) => p.billing !== "one_time") ? t("Term") : t("Format")}
                      </label>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {ps.map((p) => {
                          const on = p.price_id === (price && price.price_id);
                          return (
                            <button key={p.price_id}
                              onClick={() => setVariantPick((v) => ({ ...v, [svc.service_key]: p.price_id }))}
                              style={{
                                padding: "7px 12px", borderRadius: 10, cursor: "pointer",
                                border: `1px solid ${on ? C.gold : C.goldSoft}`,
                                background: on ? C.gold : "transparent",
                                color: on ? C.bgDeep : C.ink,
                                fontFamily: F.body, fontSize: 12.5, fontWeight: on ? 700 : 400,
                              }}>
                              {p.billing === "yearly" ? t("Yearly")
                                : p.billing === "monthly" ? t("Monthly")
                                : p.variant === "default" ? t("Standard") : p.variant}
                              <span style={{ opacity: on ? 0.75 : 0.6, marginLeft: 6 }}>{eur(p.amount_cents)}</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  {/* Fushat e këtij shërbimi. Renditja është ajo e konfigurimit —
                      pra ndryshohet pa deploy, si gjithçka tjetër te Faza 0. */}
                  {(svc.fields || []).map((f) => (
                    <div key={f.key} className="mb-2">
                      <label style={{ fontFamily: F.body, fontSize: 12, color: C.inkLight, display: "block", marginBottom: 3 }}>
                        {f.label || f.key}{f.required ? " *" : ""}
                      </label>
                      {f.type === "select" ? (
                        <select value={fieldVals[f.key] ?? ""} onChange={(e) => setFieldVals((v) => ({ ...v, [f.key]: e.target.value }))}
                          style={fieldStyle}>
                          <option value="">{t("Choose…")}</option>
                          {(f.options || []).map((o) => <option key={o} value={o}>{o}</option>)}
                        </select>
                      ) : f.type === "textarea" ? (
                        <textarea rows={2} value={fieldVals[f.key] ?? ""} placeholder={f.placeholder || ""}
                          onChange={(e) => setFieldVals((v) => ({ ...v, [f.key]: e.target.value }))}
                          style={{ ...fieldStyle, resize: "vertical" }} />
                      ) : f.type === "checkbox" ? (
                        <input type="checkbox" checked={!!fieldVals[f.key]}
                          onChange={(e) => setFieldVals((v) => ({ ...v, [f.key]: e.target.checked }))}
                          style={{ accentColor: C.gold, width: 18, height: 18 }} />
                      ) : (
                        <input type={f.type === "number" ? "number" : f.type === "date" ? "date" : "text"}
                          value={fieldVals[f.key] ?? ""} placeholder={f.placeholder || ""}
                          min={f.min} max={f.max}
                          onChange={(e) => setFieldVals((v) => ({ ...v, [f.key]: e.target.value }))}
                          style={fieldStyle} />
                      )}
                    </div>
                  ))}
                  {fieldErr && (
                    <p className="mb-2" style={{ fontFamily: F.body, fontSize: 12, color: "#8A2E2E" }}>
                      {t("Still missing")}: <b>{fieldErr}</b>
                    </p>
                  )}
                  {/* ADRESA — vetëm për atë që dërgohet. Nuk vjen nga
                      `config.fields`: një shërbim i ri fizik do ta trashëgonte
                      këtë bllok pa e konfiguruar askush, kurse fushat harrohen. */}
                  {svc.kind === "physical" && (
                    <div className="mb-2 p-2.5 rounded-lg" style={{ border: `1px solid ${C.goldSoft}` }}>
                      <p className="mb-1.5" style={{ fontFamily: F.body, fontSize: 12, fontWeight: 700, color: C.ink }}>
                        {t("Where should it be sent?")}
                      </p>
                      {/* Me marrje në dorë, rruga dhe shteti hiqen: adresa e
                          dërgesës bëhet ajo e shtypshkronjës, dhe një fushë që
                          plotësohet e pastaj shpërfillet është një gënjeshtër e
                          vogël që kushton besim. Qyteti mbetet — ai vendos cilat
                          shtypshkronja ofrohen fare. */}
                      {[["name", t("Recipient's name")], ["phone", t("Phone")], ["address", t("Street and number")],
                        ["city", t("City")], ["country", t("Country")]]
                        .filter(([k]) => !(marrjaVete && (k === "address" || k === "country")))
                        .map(([k, lab]) => (
                        <input key={k} value={shipTo[k]} placeholder={lab}
                          onChange={(e) => setShipTo((a) => ({ ...a, [k]: e.target.value }))}
                          style={{ ...fieldStyle, marginBottom: 5 }} />
                      ))}
                      {/* MARRJA NË DORË — shfaqet vetëm kur ka një shtypshkronjë
                          që e pranon, te qyteti i shkruar më sipër. */}
                      {pickupOpts.length > 0 && (
                        <div className="mb-2 mt-1">
                          <p className="mb-1" style={{ fontFamily: F.body, fontSize: 11.5, color: C.inkLight }}>
                            {t("How would you like to receive it?")}
                          </p>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                            <button onClick={() => setPickup("")}
                              style={{ padding: "6px 10px", borderRadius: 8, cursor: "pointer",
                                       border: `1px solid ${!pickup ? C.gold : C.goldSoft}`,
                                       background: !pickup ? C.gold : "transparent",
                                       color: !pickup ? C.bgDeep : C.ink, fontFamily: F.body, fontSize: 12 }}>
                              {t("Send by post")}
                            </button>
                            {pickupOpts.map((x) => {
                              const on = x.id === pickup;
                              return (
                                <button key={x.id} onClick={() => setPickup(x.id)}
                                  style={{ padding: "6px 10px", borderRadius: 8, cursor: "pointer",
                                           border: `1px solid ${on ? C.gold : C.goldSoft}`,
                                           background: on ? C.gold : "transparent",
                                           color: on ? C.bgDeep : C.ink, fontFamily: F.body, fontSize: 12 }}>
                                  {t("I'll collect it")} — {x.emri}
                                  <span style={{ opacity: 0.75, marginLeft: 4 }}>{t("free")}</span>
                                </button>
                              );
                            })}
                          </div>
                          {marrjaVete && (
                            <div className="mt-1.5 p-2 rounded-lg"
                              style={{ background: C.goldFaint || "transparent",
                                       border: `1px solid ${C.goldSoft}`,
                                       fontFamily: F.body, fontSize: 12, lineHeight: 1.6, color: C.ink }}>
                              <b>{marrjaVete.emri}</b><br />
                              {[marrjaVete.adresa, marrjaVete.qyteti].filter(Boolean).join(", ")}
                              {marrjaVete.shenim && (
                                <><br /><span style={{ color: C.inkLight }}>{marrjaVete.shenim}</span></>
                              )}
                              <br />
                              {/* Njoftimi shkon te BLERËSI, sepse vetëm ai ka
                                  llogari. Nëse posteri është dhuratë për dikë në
                                  një qytet tjetër, atij i shkon fjala prej teje
                                  — dhe kjo thuhet, jo nënkuptohet. Një premtim
                                  që s'e mbajmë dot është më keq se asnjë. */}
                              <span style={{ color: C.inkLight, fontSize: 11.5 }}>
                                {t("We will tell you when it is ready — pass the details on to whoever collects it. They should bring the order number and the name above.")}
                              </span>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Posta fshihet kur porosia merret në dorë — një çmim që
                          s'do të paguhet është një pyetje e kotë. */}
                      {marrjaVete ? null : shipIncluded ? (
                        <p style={{ fontFamily: F.body, fontSize: 12, color: C.gold, fontWeight: 700 }}>
                          ✓ {t("Postage included in the price")}
                        </p>
                      ) : shipRates.length > 0 ? (
                        <>
                          <p className="mt-1 mb-1" style={{ fontFamily: F.body, fontSize: 11.5, color: C.inkLight }}>
                            {t("Postage")}
                          </p>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                            {shipRates.map((r) => {
                              const on = r.id === shipRate;
                              const falas = r.free_over_cents != null
                                && price && price.amount_cents * qty >= r.free_over_cents;
                              return (
                                <button key={r.id} onClick={() => setShipRate(r.id)}
                                  style={{ padding: "6px 10px", borderRadius: 8, cursor: "pointer",
                                           border: `1px solid ${on ? C.gold : C.goldSoft}`,
                                           background: on ? C.gold : "transparent",
                                           color: on ? C.bgDeep : C.ink, fontFamily: F.body, fontSize: 12 }}>
                                  {r.label} <span style={{ opacity: 0.75, marginLeft: 4 }}>
                                    {falas ? t("free") : eur(r.amount_cents)}
                                  </span>
                                </button>
                              );
                            })}
                          </div>
                        </>
                      ) : null}
                    </div>
                  )}
                  <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2}
                    placeholder={t("Anything we should know? (optional)")}
                    style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: `1px solid ${C.goldSoft}`,
                             background: "transparent", color: C.ink, fontFamily: F.body, fontSize: 13, resize: "vertical" }} />
                  <div className="flex gap-2 mt-2">
                    <button onClick={() => place(svc)} disabled={busy}
                      className="flex-1 py-2.5 rounded-lg text-sm font-semibold"
                      style={{ background: C.gold, color: C.bgDeep, border: "none", cursor: "pointer",
                               fontFamily: F.body, opacity: busy ? 0.6 : 1 }}>
                      {busy ? t("Sending…") : (() => {
                        // I NJËJTI RREGULL SI TE SERVERI (`fn_shipping_for`):
                        // falas mbi prag, zero kur posta është e përfshirë.
                        const sub = price ? price.amount_cents * qty : 0;
                        const r = rateOf(shipRate);
                        const post = (svc.kind !== "physical" || shipIncluded || !r) ? 0
                          : (r.free_over_cents != null && sub >= r.free_over_cents) ? 0 : r.amount_cents;
                        return `${t("Confirm order")} · ${eur(sub + post)}`
                          + (post > 0 ? ` (${t("incl. postage")} ${eur(post)})` : "");
                      })()}
                    </button>
                    <button onClick={() => setOpenKey(null)} className="px-4 rounded-lg text-sm"
                      style={{ background: "transparent", border: `1px solid ${C.goldSoft}`, color: C.ink,
                               cursor: "pointer", fontFamily: F.body }}>
                      {t("Back")}
                    </button>
                  </div>
                  <p style={{ fontFamily: F.body, fontSize: 11, color: C.inkLight, marginTop: 6, lineHeight: 1.5 }}>
                    {t("No payment now — after you order, we contact you with the payment details.")}
                  </p>
                </div>
              )}
            </div>
          );
        })}

        {/* ---------------- POROSITË E MIA ---------------- */}
        {orders && orders.length > 0 && (
          <>
            <p className="mt-6 mb-2" style={{ fontFamily: F.display, fontSize: 16, fontWeight: 600, color: C.onBg }}>
              {t("My orders")}
            </p>
            {orders.map((o) => {
              const step = STATUS_STEP[o.status] || 0;
              const dead = o.status === "cancelled" || o.status === "refunded";
              return (
                <div key={o.id} className="mb-2.5 p-3.5" style={{ ...card, opacity: dead ? 0.65 : 1 }}>
                  <div className="flex items-center gap-2">
                    <span style={{ fontFamily: F.mono, fontSize: 11.5, color: C.inkLight }}>{o.order_no}</span>
                    {o.te_reja > 0 && (
                      <span style={{ minWidth: 17, height: 17, borderRadius: 9, background: C.gold,
                                     color: C.bgDeep, fontSize: 10.5, fontWeight: 700, display: "inline-flex",
                                     alignItems: "center", justifyContent: "center", padding: "0 5px" }}>
                        {o.te_reja}
                      </span>
                    )}
                    <span style={{ flex: 1 }} />
                    <span style={{ fontFamily: F.body, fontSize: 12, fontWeight: 700,
                                   color: o.status === "completed" ? C.gold : dead ? C.inkLight : C.ink }}>
                      {t(STATUS_SQ[o.status] || o.status)}
                    </span>
                  </div>
                  {(o.items || []).map((it, i) => (
                    <div key={i} className="flex gap-2 mt-1.5" style={{ fontFamily: F.body, fontSize: 13, color: C.ink }}>
                      <span style={{ flex: 1 }}>{it.name}{it.qty > 1 ? ` × ${it.qty}` : ""}</span>
                      <span style={{ fontWeight: 600 }}>{eur(it.amount_cents)}</span>
                    </div>
                  ))}
                  {/* Shiriti i përparimit — pesë hapa të vegjël, pa fjalë. */}
                  {!dead && (
                    <div className="flex gap-1 mt-2.5">
                      {[1, 2, 3, 4, 5].map((n) => (
                        <span key={n} style={{ flex: 1, height: 3, borderRadius: 2,
                          background: n <= step ? C.gold : C.goldSoft, opacity: n <= step ? 1 : 0.4 }} />
                      ))}
                    </div>
                  )}
                  {/* Skedarët e dorëzuar (PDF etj.) — kur stafi i ngjit te output. */}
                  {(o.items || []).some((it) => it.output && it.output.url) && (
                    <div className="mt-2">
                      {(o.items || []).filter((it) => it.output && it.output.url).map((it, i) => (
                        <a key={i} href={it.output.url} target="_blank" rel="noreferrer"
                          style={{ fontFamily: F.body, fontSize: 12.5, color: C.gold, textDecoration: "underline" }}>
                          ⬇ {t("Download")} — {it.name}
                        </a>
                      ))}
                    </div>
                  )}
                  {/* Vepra e porosisë — posteri vetë. Butoni shfaqet gjithmonë
                      kur skedari ekziston, edhe para pagesës: një buton që
                      mungon lexohet si defekt, kurse një buton që të thotë
                      "hapet pas pagesës" të shpjegon rregullin. */}
                  {!dead && (o.items || []).some((it) => it.output && it.output.artwork) && (
                    <button onClick={() => openArtwork(o.id)} disabled={dlBusy === o.id}
                      className="mt-2 px-3 py-1.5 rounded-md text-xs"
                      style={{ background: fn_paidLook(o.status) ? C.gold : "transparent",
                               color: fn_paidLook(o.status) ? C.bgDeep : C.inkLight,
                               border: `1px solid ${fn_paidLook(o.status) ? C.gold : C.goldSoft}`,
                               fontFamily: F.body, fontWeight: 700 }}>
                      {dlBusy === o.id ? "…" : fn_paidLook(o.status)
                        ? `⬇ ${t("Download your file")}`
                        : `🔒 ${t("Opens after payment")}`}
                    </button>
                  )}
                  {o.status === "awaiting_payment" && payInfo && (
                    <div className="mt-2 px-3 py-2.5 rounded-lg" style={{ background: C.panelSoft, border: `1px solid ${C.gold}` }}>
                      <p style={{ fontFamily: F.body, fontSize: 12, fontWeight: 700, color: C.ink, marginBottom: 3 }}>
                        {t("How to pay")}
                      </p>
                      <p style={{ fontFamily: F.body, fontSize: 12.5, color: C.ink, lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{payInfo}</p>
                      <p style={{ fontFamily: F.body, fontSize: 11.5, color: C.inkLight, marginTop: 4 }}>
                        {t("Reference")}: <span style={{ fontFamily: F.mono, color: C.gold }}>{o.order_no}</span>
                      </p>
                    </div>
                  )}
                  {/* Posta, e ndarë nga artikujt — që totali të mos duket i
                      pashpjegueshëm kur klienti e krahason me çmimin e vitrinës. */}
                  {o.shipping_cents > 0 && (
                    <div className="flex gap-2 mt-1" style={{ fontFamily: F.body, fontSize: 12.5, color: C.inkLight }}>
                      <span style={{ flex: 1 }}>{t("Postage")}{o.shipping_label ? ` · ${o.shipping_label}` : ""}</span>
                      <span>{eur(o.shipping_cents)}</span>
                    </div>
                  )}
                  {/* GJURMIMI. Ky numër vjen nga shtypshkronja dhe mbërrin këtu
                      pa e prekur askush — pa email që dikush duhet ta përcjellë,
                      pa hap që harrohet të premten në mbrëmje. */}
                  {o.tracking_no && (
                    <div className="mt-2 px-3 py-2 rounded-lg" style={{ background: C.panelSoft, border: `1px solid ${C.gold}` }}>
                      <p style={{ fontFamily: F.body, fontSize: 12, fontWeight: 700, color: C.ink }}>
                        📮 {t("On its way")}{o.carrier ? ` · ${o.carrier}` : ""}
                      </p>
                      <p style={{ fontFamily: F.mono, fontSize: 13.5, color: C.gold, marginTop: 2 }}>
                        {o.tracking_no}
                      </p>
                    </div>
                  )}
                  {/* Butoni del vetëm kur ka kuptim: porosia është nisur ose
                      është gati te banaku. Te 'delivered' e më tej s'ka çfarë të
                      konfirmohet, dhe një buton që s'bën gjë mëson njerëzit të
                      mos i besojnë butonave. */}
                  {["shipped", "ready"].includes(o.status) && (
                    <button onClick={() => confirmReceived(o.id)}
                      className="mt-2 w-full py-2 rounded-lg"
                      style={{ fontFamily: F.body, fontSize: 13, fontWeight: 700,
                               background: C.gold, color: "#1A1710", border: "none", cursor: "pointer" }}>
                      ✓ {o.status === "ready" ? t("I collected it") : t("It arrived")}
                    </button>
                  )}
                  {o.ship_to && !o.ship_to.pickup && (
                    <p className="mt-1" style={{ fontFamily: F.body, fontSize: 11.5, color: C.inkLight }}>
                      📦 {[o.ship_to.name, o.ship_to.address, o.ship_to.city, o.ship_to.country].filter(Boolean).join(", ")}
                    </p>
                  )}
                  {/* MARRJA NË DORË — të dhënat që duhen përcjellë. Butoni i
                      kopjimit ekziston sepse ai që shkon te banaku shpesh NUK ka
                      llogari këtu: e vetmja rrugë deri te ai është një mesazh
                      prej blerësit, dhe një mesazh që duhet shkruar me dorë nga
                      pesë rreshta ekrani shkruhet gabim. */}
                  {o.ship_to && o.ship_to.pickup && (
                    <div className="mt-1 p-2 rounded-lg"
                      style={{ border: `1px solid ${C.goldSoft}`, fontFamily: F.body,
                               fontSize: 11.5, color: C.inkLight, lineHeight: 1.6 }}>
                      🏬 <b style={{ color: C.ink }}>{t("Collect from")}: {o.ship_to.pickup_vendor}</b><br />
                      {[o.ship_to.address, o.ship_to.city].filter(Boolean).join(", ")}
                      {o.ship_to.pickup_phone && <> · {o.ship_to.pickup_phone}</>}
                      {o.ship_to.pickup_note && <><br />{o.ship_to.pickup_note}</>}
                      <br />{t("Collected by")}: <b style={{ color: C.ink }}>{o.ship_to.name}</b>
                      {o.ship_to.phone && <> · {o.ship_to.phone}</>}
                      <br />
                      <button onClick={() => {
                        const teksti = [
                          `${t("Order")} ${o.order_no}`,
                          `${t("Collect from")}: ${o.ship_to.pickup_vendor}`,
                          [o.ship_to.address, o.ship_to.city].filter(Boolean).join(", "),
                          o.ship_to.pickup_phone ? `${t("Phone")}: ${o.ship_to.pickup_phone}` : null,
                          o.ship_to.pickup_note || null,
                          `${t("Collected by")}: ${o.ship_to.name}`,
                        ].filter(Boolean).join("\n");
                        try {
                          navigator.clipboard.writeText(teksti);
                          setCopied(o.order_id || o.order_no);
                          setTimeout(() => setCopied(""), 2000);
                        } catch (_e) { /* asgjë — shfletues pa clipboard */ }
                      }}
                        style={{ marginTop: 5, padding: "4px 10px", borderRadius: 8, cursor: "pointer",
                                 border: `1px solid ${C.goldSoft}`, background: "transparent",
                                 color: C.gold, fontFamily: F.body, fontSize: 11.5 }}>
                        {copied === (o.order_id || o.order_no) ? `✓ ${t("Copied")}` : t("Copy the details")}
                      </button>
                    </div>
                  )}

                  {/* "E PAGOVA" — nuk e ndryshon statusin, e njofton. Verifikimin
                      e bën stafi te banka. Një buton që e shënon vetë porosinë të
                      paguar do të ishte buton që gënjen, dhe një ditë do ta
                      shtypte dikush pa paguar. */}
                  {o.status === "awaiting_payment" && (
                    <div className="mt-2 flex gap-2" style={{ flexWrap: "wrap" }}>
                      <input value={payRef[o.id] || ""} onChange={(e) => setPayRef((r) => ({ ...r, [o.id]: e.target.value }))}
                        placeholder={t("Payment reference (optional)")}
                        style={{ ...fieldStyle, flex: 1, minWidth: 150, marginBottom: 0 }} />
                      <button onClick={() => declarePaid(o.id)}
                        className="px-3 py-1.5 rounded-md text-xs font-semibold"
                        style={{ background: C.gold, color: C.bgDeep, border: "none", cursor: "pointer", fontFamily: F.body }}>
                        {t("I have paid")}
                      </button>
                    </div>
                  )}

                  {/* BISEDA. Deri sot kjo faqe ishte e heshtur në të dy drejtimet. */}
                  <button onClick={() => openThread(o.id)}
                    className="mt-2 text-xs"
                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer",
                             color: C.gold, fontFamily: F.body, textDecoration: "underline" }}>
                    {thread[o.id] ? t("Hide the conversation") : t("Conversation and history")}
                    {o.mesazhe > 0 ? ` (${o.mesazhe})` : ""}
                  </button>
                  {thread[o.id] && (
                    <div className="mt-2 p-2.5 rounded-lg" style={{ background: C.panelSoft }}>
                      {thread[o.id].map((e, i) => (
                        <div key={i} className="mb-1.5" style={{ fontFamily: F.body, fontSize: 12.5,
                              color: e.nga === "system" ? C.inkLight : C.ink,
                              textAlign: e.nga === "client" ? "right" : "left" }}>
                          <span style={{ display: "inline-block", maxWidth: "90%", padding: e.lloji === "message" ? "5px 9px" : 0,
                                         borderRadius: 9,
                                         background: e.lloji === "message" ? (e.nga === "client" ? C.gold : "#fff") : "transparent",
                                         color: e.lloji === "message" && e.nga === "client" ? C.bgDeep : "inherit" }}>
                            {e.teksti}
                          </span>
                          <div style={{ fontSize: 10, color: C.inkLight, marginTop: 1 }}>
                            {new Date(e.kur).toLocaleString("sq")}
                          </div>
                        </div>
                      ))}
                      {!dead && (
                        <div className="flex gap-2 mt-2">
                          <input value={msg[o.id] || ""} onChange={(e) => setMsg((m) => ({ ...m, [o.id]: e.target.value }))}
                            onKeyDown={(e) => { if (e.key === "Enter") sendMsg(o.id); }}
                            placeholder={t("Write to us about this order…")}
                            style={{ ...fieldStyle, flex: 1, marginBottom: 0 }} />
                          <button onClick={() => sendMsg(o.id)}
                            className="px-3 rounded-md text-xs font-semibold"
                            style={{ background: C.gold, color: C.bgDeep, border: "none", cursor: "pointer", fontFamily: F.body }}>
                            {t("Send")}
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                  {(o.status === "submitted" || o.status === "awaiting_payment") && (
                    <button onClick={() => cancel(o.id)} disabled={busy}
                      className="mt-2 px-3 py-1 rounded-md text-xs"
                      style={{ background: "transparent", border: `1px solid ${C.goldSoft}`,
                               color: C.inkLight, cursor: "pointer", fontFamily: F.body }}>
                      {t("Cancel order")}
                    </button>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}
